require("style-loader!css-loader!sass-loader!./font-awesome-sass-styles.loader!./font-awesome-sass.config.js");



//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass-loader/index.js
// module id = 490
// module chunks = 2